<template>
    <div class="d-flex flex-column justify-content-center align-items-center" style="height: 80vh;">
        <h1 class="display-1">404</h1>
        <h2>Page non trouvée</h2>
        <p class="text-muted">La page que vous recherchez n'existe pas.</p>
        <button class="btn btn-primary mt-3" @click="$router.push({ name: 'home' })">
            <i class="bi bi-house-fill fs-3"></i>
            Retour à l'accueil</button>
    </div>
</template>